import { Component, Input, TemplateRef } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-grid-toolbar',
    templateUrl: './grid-toolbar.component.html',
    styleUrls: ['./grid-toolbar.component.scss']
})
export class GridToolbarComponent extends BaseComponent<BaseState> {
    @Input() Grid: DxDataGridComponent;
    @Input() ShowAddButton: boolean;
    @Input() AddButtonText: string;
    @Input() AddButtonNavPath: string;
    @Input() AddButtonNavParams: any;
    @Input() Title: string;
    @Input() StartExtraButtonsTemplate: TemplateRef<any>;
    @Input() EndExtraButtonsTemplate: TemplateRef<any>;

    constructor(A: ServiceBagService) {
        super(A, 'GridToolbarComponent', BaseState);
    }

    HasContent(content: any) {
        return content && content.childElementCount > 0;
    }
}
